import { defaultTo, evolve, omit, pipe } from 'ramda';
import { isClientSide } from '@moda/portal-stanchions';
import { UseUserQuery_user as User } from '../generated/types/UseUserQuery';
import { tc } from './trackingContext';
import { AuthPayload } from './authenticate';

export const identifyUser = (user: AuthPayload | User) => {
  if (!isClientSide()) return;

  if (user.id != null) {
    tc.identify(user.id, pipe(omit(['id']), evolve({ clientTier: defaultTo('NA') }))(user));
  } else {
    tc.identify();
  }
};
